export const GET_DOCTOR_REQUEST = 'getDoctorRequest';
export const GET_DOCTOR_SUCCESS = 'getDoctorSuccess';
export const GET_DOCTOR_FAIL = 'getDoctorFail';